import { CategoryCard, getCategoryIcon } from "./CategoryCard";
import { mapDatabaseToDisplayCategory, mapDisplayToDatabaseCategory } from "@/utils/categoryMapping";

interface AgeCategoriesSectionProps {
  age: string;
  categories: Array<{ name: string }>;
  openCategory: string | null;
  onCategoryClick: (categoryId: string) => void;
  getLevelsForAgeAndCategory: (age: string, category: string) => Array<{ name: string; difficulty: string; title?: string; id: string }>;
  onLevelClick: (age: string, category: string, level: string) => void;
}

const getCategoryName = (categoryName: string) => {
  return mapDisplayToDatabaseCategory(categoryName);
};

const getDisplayCategoryName = (categoryName: string) => {
  return mapDatabaseToDisplayCategory(categoryName);
};

const getUniqueLevels = (levels: Array<{ name: string; difficulty: string; title?: string; id: string }>) => {
  console.log("Raw levels before processing:", levels);
  
  const uniqueLevels = new Map();
  levels.forEach(level => {
    const key = level.id;
    if (!uniqueLevels.has(key)) {
      uniqueLevels.set(key, level);
    }
  });

  const sortedLevels = Array.from(uniqueLevels.values())
    .sort((a, b) => {
      const getStageNumber = (item: { title?: string; difficulty: string }) => {
        const titleMatch = (item.title || '').match(/stage\s*(\d+)/i);
        if (titleMatch) return parseInt(titleMatch[1], 10);
        
        const difficultyMatch = item.difficulty.match(/stage(\d+)/i);
        if (difficultyMatch) return parseInt(difficultyMatch[1], 10);
        
        return 0;
      };
      
      return getStageNumber(a) - getStageNumber(b);
    });

  console.log("Processed and sorted levels:", sortedLevels);
  return sortedLevels;
};

export const AgeCategoriesSection = ({
  age,
  categories,
  openCategory,
  onCategoryClick,
  getLevelsForAgeAndCategory,
  onLevelClick,
}: AgeCategoriesSectionProps) => {
  console.log("Categories for age", age, ":", categories);
  
  return (
    <div className="flex flex-col space-y-4">
      {categories.map(({ name }) => {
        const dbCategoryName = getCategoryName(name);
        const displayName = getDisplayCategoryName(name);
        const levels = getLevelsForAgeAndCategory(age, dbCategoryName);
        
        console.log("Category:", name, "DB name:", dbCategoryName, "Display name:", displayName, "Levels:", levels);
        
        if (levels.length === 0) {
          return null;
        }

        const uniqueLevels = getUniqueLevels(levels);

        return (
          <CategoryCard
            key={name}
            name={displayName}
            icon={getCategoryIcon(displayName)}
            isOpen={openCategory === `${age}-${name}`}
            onToggle={() => onCategoryClick(`${age}-${name}`)}
            levels={uniqueLevels}
            onLevelClick={(levelName) => onLevelClick(age, dbCategoryName, levelName)}
          />
        );
      })}
    </div>
  );
};
